import { useList } from "@refinedev/core";

interface PlanFeature {
  id: string;
  feature_id: string;
  service_user_plan_id: string;
  value: number | string;
  membership_id: string | null;
}

interface Feature {
  id: string;
  name: string;
}

export const useServicePricing = (serviceType: 'help' | 'consultation') => {
  
  const { data: features } = useList<Feature>({
    resource: "features",
    filters: [
      {
        field: "name",
        operator: "eq",
        value: serviceType,
      },
    ],
    pagination: { current: 1, pageSize: 1 },
    meta: {
      fields: ["id", "name"]
    }
  });

  const { data: planFeatures } = useList<PlanFeature>({
    resource: "plan_features",
    filters: [
      {
        field: "feature_id",
        operator: "eq",
        value: features?.data?.[0]?.id || "",
      },
    ],
    queryOptions: {
      enabled: !!features?.data?.[0]?.id,
    },
    meta: {
      fields: ["id", "feature_id", "service_user_plan_id", "value", "membership_id"]
    }
  });

  const getPriceByMembership = (membershipId: string) => {
    return planFeatures?.data?.find(pf => 
      pf.membership_id === membershipId
    )?.value || 0;
  };

  const getPriceByPlan = (planId: string) => {
    return planFeatures?.data?.find(pf => 
      pf.service_user_plan_id === planId && !pf.membership_id
    )?.value || 0;
  };

  const basicPrice = Number(getPriceByPlan("6ce44c8d-db4c-4f43-bc4c-cb052bb9fb0e"));
  const premiumPriceBasic = Number(getPriceByMembership("148a7be2-cc89-4467-90b4-1800eb7d926b"));
  const premiumPricePro = Number(getPriceByMembership("4e01dfd3-8530-42a1-98c4-416efd25e9e8"));

  return {
    basicPrice,
    premiumPriceBasic,
    premiumPricePro,
    isLoading: !features?.data || !planFeatures?.data,
  };
};